import React from 'react';
import Navbar from "../../components/navbar/index.jsx";
import ListaGarantia from "../../components/ListaGarantia/listagarantia.jsx";

function Home(){

     var Dias = localStorage.getItem("Dias");
     var QtdeCtr = localStorage.getItem("QtdeCtr");
     var UltimaVisita = localStorage.getItem("UltimaVisita");
     var ProximaVisita = localStorage.getItem("ProximaVisita");
     var NomeUsuario = localStorage.getItem("NomeUsuario");
 
     return<>

     <Navbar/>

     <div className="container-fluid mt-page titulo">
          <div className="m-2 mt-4 ">
               <div className="invisivel">
                          <h6> '' </h6> 
                </div> 
               <h6> {NomeUsuario} </h6>
               <h2> Dashboard </h2>      

          </div>
           
          <div className="row">
              <div className="col-md-2">
                   <div className="card">
                        <div className="card-header text-center">
                                Ultima Visita:                                  
                        </div>
                        <div className="card-body text-center">
                             <h6 className="card-litle">{UltimaVisita} </h6>
                         </div>
                   </div>
               </div>    
               
               <div className="col-md-2">
                   <div className="card">
                        <div className="card-header text-center">
                                Próxima Visita:                                  
                        </div>
                        <div className="card-body text-center">
                             <h6 className="card-litle">{ProximaVisita} </h6>
                         </div>
                   </div>
               </div>

               <div className="col-md-2">
                   <div className="card">
                         <div className="card-header text-center">
                                Ainda faltam :                                   
                        </div>
                        <div className="card-body text-center">
                             <h6 className="card-litle">{Dias} dia(s). </h6>
                         </div>
                   </div>
               </div>
               <div className="col-md-2">
                   <div className="card">
                         <div className="card-header text-center">
                                Contratos Vigentes:                                  
                        </div>
                        <div className="card-body text-center">
                             <h6 className="card-litle">{QtdeCtr} </h6>
                         </div>
                   </div>
               </div>
            
          </div>
          <div className="invisivel">
                  <h6> '' </h6> 
          </div>         
          <ListaGarantia/>
     </div>
     

</>

}

export default Home;
